export default "__VITE_ASSET___wYWMubi__"